module.exports = __webpack_public_path__ + "img/部分选择.b750c25f.svg";